import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { BottomNavigation } from 'components/common/bottomNavigation/BottomNavigation';
import { useMeetingList } from 'hooks/useMeeting';
import { meetingStore } from 'store/meetingStore';
import './Functions.css';

export const Functions = () => {
    const navigate = useNavigate();
    const { data, status } = useMeetingList();

    // 컴포넌트 마운트 시 모임 목록 조회
    useEffect(() => {
        meetingStore.onGetMeetingList();
    }, []);

    // 데이터 확인을 위한 로그
    useEffect(() => {
        console.log('Functions - Meeting List Data:', data);
        console.log('Functions - Meeting List Status:', status);
    }, [data, status]);

    // API에서 받아온 모임 개수 계산
    // API 응답 구조: { data: [...], pageInfo: {...} }
    const meetingCount = data?.data?.length || data?.pageInfo?.totalCount || 0;

    const features = [
        {
            id: 1,
            icon: '➕',
            title: '모임 생성',
            description: '새로운 모임 만들기',
            route: '/meeting/create'
        },
        {
            id: 2,
            icon: '📋',
            title: '나의 모임',
            description: `참여 중인 모임 ${meetingCount}개`,
            route: '/my-meetings'
        },
        {
            id: 3,
            icon: '🕐',
            title: '일정 조율',
            description: '모임 일정 조율하기',
            route: '/schedule/select'
        },
        {
            id: 4,
            icon: '🔍',
            title: '코드로 참여',
            description: '초대 코드로 모임 참여',
            route: '/join-code'
        }
    ];

    return (
        <div className="functions-wrapper">
            <div className="functions-content">
                {/* Header */}
                <div className="functions-header">
                    <div className="functions-logo">MO2</div>
                    <div className="functions-user-icon">👤</div>
                </div>

                {/* Title */}
                <div className="functions-title">주요 기능</div>

                {/* Feature Grid */}
                <div className="functions-grid">
                    {features.map(feature => (
                        <button
                            key={feature.id}
                            className="function-card"
                            onClick={() => navigate(feature.route)}
                        >
                            <div className="function-card-icon">{feature.icon}</div>
                            <div className="function-card-content">
                                <div className="function-card-title">{feature.title}</div>
                                <div className="function-card-description">{feature.description}</div>
                            </div>
                            <div className="function-card-arrow">→</div>
                        </button>
                    ))}
                </div>
            </div>

            <BottomNavigation />
        </div>
    );
};
